
export const environment = {
  production: false,
  staging: false,
  dev: true,
  apiBaseUrl:"https://dev.api.safetyinminutes.ca/api/"
};

